export default __webpack_public_path__ + "static/media/error.354dc86a.svg";